exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ManagedResourceConfig .rainbow-icon {\n  text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.5);\n}\n.ManagedResourceConfig .paused-warning {\n  background-color: var(--color-warning-light);\n}\n", ""]);

